<div class="col-lg-6 question-label">
    <label>{{label ?? question.questionLabel}}
        <span *ngIf="question?.required">*</span>
    </label>
</div>
<div class="col-lg-6">
    <input class="form-control"        
        [class.validate_error_cls]="isFormSubmitted && meAsControl.invalid"
        [placeholder]="waterMark" value="{{value}}"
        maxlength="maxlength" minlength="minlength"
        [name]="question?.name" (change) = "onValueChanged($event)"
        #txtboxCtrl>    
    <span style="color: red;" *ngIf="isFormSubmitted && meAsControl.invalid">
           {{validationMessage ?? (meAsControl.errors | json )}}
    </span>
</div>